import { NameFieldsProps as Props } from "./NameFields";
export { default } from "./NameFields";
export type NameFieldsProps = Props;
